import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const unmarkAutoRetryGettingEstimate = async (phoneNumber: string) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
    },
    mutation: graphql(`
      mutation UnmarkAutoRetryGettingEstimate($phoneNumber: String!) {
        unmarkAutoRetryGettingEstimate(phoneNumber: $phoneNumber)
      }
    `),
  });

  return response.data?.unmarkAutoRetryGettingEstimate ?? false;
};
